
import { supabase } from '@/integrations/supabase/client';

// Helper function to get authentication token
export const getAuthToken = async (): Promise<string | undefined> => {
  const { data } = await supabase.auth.getSession();
  return data?.session?.access_token;
};
